import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const CopyIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      d="M12.252 0H6.326C5.28867 0 4.44467 0.844 4.44467 1.88133V4.44467H1.88133C0.844 4.44467 0 5.28867 0 6.32533V12.2513C0 13.2893 0.844 14.1327 1.88133 14.1327H7.80733C8.84467 14.1327 9.68867 13.2887 9.68867 12.2513V9.688H12.2513C13.2887 9.688 14.1327 8.844 14.1327 7.80733V1.882C14.1333 0.844 13.2893 0 12.252 0ZM8.88867 12.2513C8.88867 12.848 8.40333 13.3333 7.80733 13.3333H1.88133C1.28467 13.3333 0.8 12.8473 0.8 12.2513V6.32533C0.8 5.72867 1.28533 5.244 1.88133 5.244H4.444V7.80733C4.444 8.84467 5.288 9.688 6.32533 9.688H8.88867V12.2513ZM13.3333 7.80733C13.3333 8.404 12.848 8.88867 12.252 8.88867H6.326C5.72933 8.88867 5.24467 8.40333 5.24467 7.80733V1.882C5.24467 1.28533 5.73 0.8 6.326 0.8H12.252C12.8487 0.8 13.3333 1.286 13.3333 1.882V7.80733Z"
    />
  </svg>
);

CopyIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

CopyIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(14, 14),
};

export default CopyIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/copy.js